// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__tVt2Z","title":"Info_title__24eXM","links":"Info_links__OjPKX","link":"Info_link__1SoQ3","logo":"Info_logo__LYpA7"};